module.exports = __webpack_public_path__ + "img/baroka-logo-icon.fb349b83.png";